/**
 *  Alaska: Editor
 *  Public: Contact form
 *
 *  @version 1.0
 */

document.addEventListener('alpine:init', () => {
    Alpine.data('ContactForm', () => ({
        state: "default",
        loading: false,

        form: {
            firstName: "",
            lastName: "",
            email: "",
            confirmEmail: "",
            company: "",
            description: [],
            message: "",
            newsletter: false
        },

        errors: {
            firstName: "",
            lastName: "",
            email: "",
            confirmEmail: "",
            company: "",
            description: "",
            message: ""
        },

        // ---- State ---- //

        get loading_state() {
            return this.loading === true;
        },

        get default_state() {
            return this.state === "default" && this.loading === false;
        },

        get success_state() {
            return this.state === "success" && this.loading === false;
        },

        reset()
        {
            setTimeout(() => {
                this.state = "default";
                this.form = {
                    firstName: "",
                    lastName: "",
                    email: "",
                    confirmEmail: "",
                    company: "",
                    description: [],
                    message: "",
                    newsletter: false
                };
                this.loading = false;
            }, 3000);
        },

        // ---- Form ---- //

        addDescription(event, type) {
            if(event.target.checked) {
                this.form.description.push(type);
            } else {
                this.form.description.pop(type);
            }
        },

        validate_form() {
            if(this.form.firstName.trim() === "") {
                this.errors.firstName = "First name is required";
            } else {
                this.errors.firstName = "";
            }

            if(this.form.lastName.trim() === "") {
                this.errors.lastName = "Last name is required";
            } else {
                this.errors.lastName = "";
            }

            if(this.form.email.trim() === "") {
                this.errors.email = "Email address is required";
            } else {
                this.errors.email = "";
            }

            if(this.form.confirmEmail.trim() === "") {
                this.errors.confirmEmail = "Email confirmation is required";
            } else {
                this.errors.confirmEmail = "";
            }

            if(this.form.description.length === 0) {
                this.errors.description = "This field is required";
            } else {
                this.errors.description = "";
            }

            if(this.form.message.trim() === "") {
                this.errors.message = "Message is required";
            } else {
                this.errors.message = "";
            }

            let status = true;
            Object.keys(this.errors).forEach((input) => {
                if(this.errors[input].length > 0) {
                    status = false;
                }
            });

            return status;
        },

        async submit()
        {
            if (!this.validate_form())
            {
                Notification.render("Please fill out the required fields.", "error")
                return;
            }

            this.loading = true;

            try {
                const response = await fetch("/alaska/public/", {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        controller: "Marketing",
                        action: "contact",
                        data: this.form
                    })
                });

                const result = await response.json();
                console.log(result)

                this.loading = false;

                if (result.type === "success") {
                    this.state = "success";
                    this.reset();
                }
            } catch (error) {
                console.error(error);
            }
        },

    }));
})
